module.exports = __webpack_public_path__ + "assets/img/harmoni-icon.24cef3e9.png";